export type SalesChecklistBehaviors =
    | "PROTECTION"
    | "TECH_SUPPORT"
    | "FUTURE_DEVICES"
    | "NON_PARTNER_DEVICES"
    | "IN_HOME_INSTALLATION"
    | "IN_STORE_SERVICES"
    | "ASK_SALE"
    | "BILLING"
    | "COVERAGE"
    | "TRANSITION"
    | "RAPPORT"
    | "ENGAGEMENT_QUESTION"
    | "DISCOVERY_QUESTION"
    | "ENROLLMENT_CELEBRATION"
    | "ASK_SEND_LINK";

export interface SalesChecklistMentions {
    name: SalesChecklistBehaviors;
    value: boolean;
}
